import Cookies from 'js-cookie'

/**
 * @module cookie
 * @category client
 */

/**
 *  @category client
 *  @hideconstructor
 */
class Cookie {
  /**
   * Sets a cookie with the given name and value.
   *
   * @param {string} name - The name of the cookie to set.
   * @param {*} value - The value of the cookie to set.
   * @param {Date|number|undefined} exp - The expiration date or time in milliseconds. If not provided, defaults to one hour from now.
   * @returns {void}
   */
  static setCookie (name, value, exp) {
    // eslint-disable-next-line no-param-reassign
    if (!exp) exp = new Date(new Date().getTime() + 60 * 60 * 1000) // One hour

    Cookies.set(name, value, { expires: exp })
  }

  /**
   * Retrieves the value of the cookie.
   *
   * @param {string} name - The name of the cookie.
   * @returns {string|undefined} The cookie value or undefined if not found.
   */
  static getCookie (name) {
    return Cookies.get(name)
  }

  /**
   * Removes a cookie by its name and optionally by domain.
   *
   * @param {string} name - The name of the cookie to remove.
   * @param {?string} [domain=null] - The domain for which to remove the cookie. If not provided, removes the cookie from all domains.
   * @returns {void}
   */
  static removeCookie (name, domain = null) {
    const cookieOptions = domain
      ? {
          domain
        }
      : {}
    return Cookies.remove(name, cookieOptions)
  }
}

export default Cookie
